module.exports = __webpack_public_path__ + "img/bund-3.c7fe1bc6.png";